import { createNode } from '@glueapp/graph-types';

export const ReplaceInText = createNode({
    id: 'Replace in Text',
    name: 'Replace in Text',
    description: 'Use to replace occurrences of the Pattern input with the Replacement',
    aiDescription:
        'Replaces the first occurrence of a pattern in a string. Connect the source string to "Input", the search string to "Pattern", and the replacement string to "Replacement"; outputs the result on "Output".',
    category: 'Text',
    color: '#387cc8',
    integration: undefined,
    inPorts: {
        Input: {
            kind: 'string',
        },
        Pattern: {
            kind: 'string',
        },
        Replacement: {
            kind: 'string',
        },
    },
    outPorts: {
        Output: {
            kind: 'string',
        },
    },
    execute: function (input) {
        return { output: { Output: input.inPorts.Input.replace(input.inPorts.Pattern, input.inPorts.Replacement) } };
    },
});
